import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "./index.css";

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import ProjectDetail from "./components/ProjectDetail";

import GalaxyBackgroundCanvas from "./components/GalaxyBackgroundCanvas";
import Contacts from "./components/Contacts";
import Footer from "./components/Footer";

// ---------------------- EASING FUNZIONE ----------------------
const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

function App() {
  const [showLoader, setShowLoader] = useState(true);
  const [progress, setProgress] = useState(0);
  const [animateOut, setAnimateOut] = useState(false);
  const [contentReady, setContentReady] = useState(false);

  useEffect(() => {
    // ================= AOS INIT =================
    AOS.init({
      startEvent: "DOMContentLoaded",
      offset: 1,
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
    });
    // ============================================

    const duration = 1500; // totale in ms
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;

      const t = Math.min(elapsed / duration, 1); // 0..1
      const easedProgress = Math.round(easeOutCubic(t) * 100);

      setProgress(easedProgress);

      if (t < 1) {
        requestAnimationFrame(animate);
      } else {
        // animazione uscita loader
        setAnimateOut(true);

        setTimeout(() => {
          setShowLoader(false);
          setContentReady(true);

          // refresh AOS dopo repaint
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              AOS.refreshHard();
            });
          });
        }, 500);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  if (showLoader) {
    return (
      <div
        className={`fixed inset-0 flex flex-col items-center justify-center
          bg-gradient-to-b from-black via-black to-black z-50
          transition duration-500 transform ease-out ${animateOut ? "opacity-0 scale-95" : "opacity-100 scale-100"}`}
      >
        <h2 className="text-white text-lg sm:text-2xl md:text-4xl font-bold mb-6 animate-pulse">
          Loading ... {progress}%
        </h2>
        <div className="w-64 bg-gray-700 rounded-full h-2.5 overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 transition-all duration-150 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div
        className={`relative min-h-screen bg-black transition-opacity duration-1000 ease-in ${
          contentReady ? "opacity-100" : "opacity-0"
        }`}
      >
        <GalaxyBackgroundCanvas className="fixed inset-0 w-full h-full z-0 pointer-events-none" />
        <Navbar className="relative z-10" />

        <Routes>
          <Route
            path="/"
            element={
              <main className="relative z-5">
                <HeroSection />
                <About />
                <Skills />
                <Projects />
                <Contacts />
              </main>
            }
          />
          <Route path="/progetti/:id" element={<ProjectDetail />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
